<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20.1878 0C12.649 0 6.5 6.10687 6.5 13.6878C6.5 18.9102 13.028 31.124 17.0712 38.1995C18.461 40.6002 21.9567 40.6002 23.3044 38.1995C27.3476 31.124 33.8756 18.9102 33.8756 13.6878C33.8756 6.10687 27.7266 0 20.1878 0ZM20.1878 22.9534C15.0496 22.9534 10.9222 18.7839 10.9222 13.6878C10.9222 8.59173 15.0917 4.42222 20.1878 4.42222C25.2839 4.42222 29.4534 8.59173 29.4534 13.6878C29.4534 18.7839 25.326 22.9534 20.1878 22.9534Z"
      fill="currentColor"
    />
    <path
      d="M21.5981 12.3529V9.21569L20.0294 7.64706L18.4608 9.21569V10.2614H15.3235V17.5817H24.7353V12.3529H21.5981ZM17.4151 16.536H16.3693V15.4902H17.4151V16.536ZM17.4151 14.4445H16.3693V13.3987H17.4151V14.4445ZM17.4151 12.3529H16.3693V11.3072H17.4151V12.3529ZM20.5523 16.536H19.5066V15.4902H20.5523V16.536ZM20.5523 14.4445H19.5066V13.3987H20.5523V14.4445ZM20.5523 12.3529H19.5066V11.3072H20.5523V12.3529ZM20.5523 10.2614H19.5066V9.21569H20.5523V10.2614ZM23.6896 16.536H22.6438V15.4902H23.6896V16.536ZM23.6896 14.4445H22.6438V13.3987H23.6896V14.4445Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: "CategoryDestinationCityPoi"
};
</script>
